// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Copyright (c) 2025 Initiumnet Technologies. All Rights Reserved. */
/* Explore Features — dark, equal-height cards: 1 per row on phones, up to 5 on wide screens. */

.ex_page {
  --ex-bg: #000000;
  --ex-card: #0e0e0e;
  --ex-border: #2a2a2a;
  --ex-text: #ffffff;
  --ex-muted: #b4b4b4;
  --ex-subtle: #8c8c8c;
  --ex-accent: #4da3ff;
  --ex-ok: #3ddc84;
  --ex-error: #ff6b6b;

  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--ex-bg);
  color: var(--ex-text);
  font-family: "Inter", "Segoe UI", system-ui, -apple-system, Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
}

.ex_page *,
.ex_page *::before,
.ex_page *::after {
  box-sizing: border-box;
}

.ex_main {
  flex: 1 1;
  width: 100%;
  max-width: 1760px;
  margin: 0 auto;
  padding: 24px 16px 32px;
}

@media (min-width: 640px) {
  .ex_main {
    padding: 32px 24px 40px;
  }
}

/* ── Header ── */
.ex_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}

.ex_header-left {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.ex_logo {
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  object-fit: contain;
  border-radius: 14px;
}

.ex_header-title {
  margin: 0;
  font-size: clamp(22px, 3.2vw, 34px);
  font-weight: 700;
  letter-spacing: -0.02em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ex_settings-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  height: 42px;
  padding: 0 16px;
  border: 1px solid #3a3a3a;
  border-radius: 10px;
  background: rgba(36, 36, 45, 0.4);
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
}

.ex_settings-btn:hover {
  border-color: #6e6e6e;
}

@media (max-width: 480px) {
  .ex_settings-label {
    display: none;
  }
  .ex_settings-btn {
    padding: 0 12px;
  }
  .ex_logo {
    width: 44px;
    height: 44px;
  }
}

/* ── Summary bar ── */
.ex_summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 24px;
  padding: 14px 18px;
  border: 1px solid var(--ex-border);
  border-radius: 12px;
  background: rgba(36, 36, 45, 0.3);
  font-size: 14px;
  color: var(--ex-muted);
}

.ex_summary-total {
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
}

.ex_summary-total span,
.ex_price span {
  margin-left: 2px;
  font-size: 12px;
  font-weight: 400;
  color: var(--ex-subtle);
}

/* ── Grid: 1 → 2 → 3 → 4 → 5 columns ── */
.ex_grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  align-items: stretch;
}

@media (min-width: 600px)  { .ex_grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
@media (min-width: 960px)  { .ex_grid { grid-template-columns: repeat(3, minmax(0, 1fr)); } }
@media (min-width: 1280px) { .ex_grid { grid-template-columns: repeat(4, minmax(0, 1fr)); } }
@media (min-width: 1600px) { .ex_grid { grid-template-columns: repeat(5, minmax(0, 1fr)); } }

/* ── Card ── */
.ex_card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: 100%;
  overflow: hidden;
  border: 1px solid var(--ex-border);
  border-radius: 16px;
  background: var(--ex-card);
  transition: border-color 0.15s, box-shadow 0.15s;
}

.ex_card:hover {
  border-color: #3d3d3d;
}

/* .ex_card--selected {
  border-color: rgba(77, 163, 255, 0.55);
  box-shadow: 0 0 0 1px rgba(77, 163, 255, 0.25);
} */

/* .ex_card--locked {
  border-color: rgba(61, 220, 132, 0.5);
  box-shadow: 0 0 0 1px rgba(61, 220, 132, 0.2);
} */

/* Video window: always 16:9 */
.ex_video {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  flex-shrink: 0;
  overflow: hidden;
  background: #1a1a1a;
}

.ex_video img,
.ex_video iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
  object-fit: cover;
  display: block;
}

.ex_video-sample {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(120% 90% at 20% 0%, rgba(77, 163, 255, 0.35), transparent 60%),
    radial-gradient(100% 80% at 100% 100%, rgba(160, 107, 255, 0.35), transparent 60%),
    #141414;
}

.ex_play {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.ex_play svg path:first-child {
  transition: fill 0.15s;
}

button.ex_play:hover svg path:first-child,
button.ex_play:focus-visible svg path:first-child {
  fill: #ff0000;
}

button.ex_play:focus-visible {
  outline: 3px solid var(--ex-accent);
  outline-offset: -3px;
}

.ex_play--soon {
  cursor: default;
}

.ex_soon {
  padding: 3px 10px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.6);
  font-size: 11px;
  color: #e5e5e5;
}

/* Body: the Add / Remove button always sits at the bottom so rows line up */
.ex_body {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding: 14px 16px 18px;
}

.ex_card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 22px;
}

.ex_code {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  color: var(--ex-subtle);
}

.ex_badge {
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(77, 163, 255, 0.15);
  color: #9ccbff;
  font-size: 11px;
  font-weight: 600;
}

.ex_badge--default {
  background: rgba(61, 220, 132, 0.15);
  color: var(--ex-ok);
}

.ex_name-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  margin-top: 6px;
}

.ex_name {
  margin: 0;
  min-width: 0;
  font-size: 17px;
  font-weight: 600;
  line-height: 1.3;
}

.ex_price {
  margin: 0;
  flex-shrink: 0;
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;
}

.ex_subtitle {
  margin: 6px 0 0;
  font-size: 14px;
  line-height: 1.45;
  color: #dcdcdc;
}

.ex_desc {
  margin: 6px 0 0;
  font-size: 13px;
  line-height: 1.5;
  color: var(--ex-muted);
}

.ex_meta {
  display: flex;
  gap: 8px;
  margin: 14px 0 16px;
}

.ex_meta-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 30px;
  padding: 0 10px;
  border: 1px solid #333333;
  border-radius: 999px;
  background: transparent;
  color: var(--ex-muted);
  font-size: 12px;
  font-family: inherit;
  cursor: pointer;
}

.ex_meta-btn:hover {
  border-color: #6e6e6e;
  color: #ffffff;
}

.ex_meta-btn--on {
  border-color: rgba(77, 163, 255, 0.6);
  color: var(--ex-accent);
}

/* ── Buttons ── */
.ex_btn,
.ex_included {
  width: 100%;
  height: 44px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  font-family: inherit;
}

.ex_body > .ex_btn,
.ex_body > .ex_included {
  margin-top: auto;
}

.ex_btn {
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}

.ex_btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.ex_btn:focus-visible,
.ex_meta-btn:focus-visible,
.ex_settings-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(77, 163, 255, 0.45);
}

.ex_btn--add {
  border: 1px solid #ffffff;
  background: #ffffff;
  color: #000000;
}

.ex_btn--add:hover:not(:disabled) {
  background: #e2e2e2;
}

.ex_btn--remove {
  border: 1px solid #6e6e6e;
  background: transparent;
  color: #ffffff;
}

.ex_card .ex_btn--remove:hover {
  border-color: var(--ex-error);
  color: var(--ex-error);
}

.ex_btn--small {
  width: auto;
  height: 38px;
  padding: 0 18px;
  font-size: 14px;
}

.ex_included {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid rgba(61, 220, 132, 0.5);
  color: var(--ex-ok);
}

/* ── Page actions ── */
.ex_actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 36px;
}

.ex_actions-right {
  display: flex;
  gap: 12px;
}

.ex_btn--wide {
  width: auto;
  min-width: 150px;
  height: 48px;
  padding: 0 22px;
}

.ex_actions > .ex_btn--wide:hover {
  border-color: #ffffff;
}

@media (max-width: 599px) {
  .ex_actions,
  .ex_actions-right {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }
  .ex_btn--wide {
    width: 100%;
  }
  .ex_actions-right {
    flex-direction: column-reverse; /* Save above Cancel on phones */
  }
}

.ex_error {
  margin: 14px 0 0;
  text-align: right;
  font-size: 14px;
  color: var(--ex-error);
}

/* ── Reviews dialog ── */
.ex_modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(4px);
}

.ex_modal {
  position: relative;
  width: 100%;
  max-width: 480px;
  max-height: calc(100vh - 32px);
  overflow-y: auto;
  padding: 28px 24px 22px;
  border: 1px solid #333333;
  border-radius: 18px;
  background: #121212;
  color: #ffffff;
}

.ex_modal-close {
  position: absolute;
  top: 10px;
  right: 12px;
  width: 34px;
  height: 34px;
  border: 0;
  background: transparent;
  color: var(--ex-muted);
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
}

.ex_modal-title {
  margin: 0 32px 16px 0;
  font-size: 19px;
  font-weight: 600;
}

.ex_modal-textarea {
  width: 100%;
  min-height: 96px;
  padding: 12px 14px;
  border: 1px solid #4a4a4a;
  border-radius: 10px;
  background: #0a0a0a;
  color: #ffffff;
  font-size: 15px;
  font-family: inherit;
  resize: vertical;
}

.ex_modal-textarea:focus {
  outline: none;
  border-color: var(--ex-accent);
  box-shadow: 0 0 0 3px rgba(77, 163, 255, 0.3);
}

.ex_modal-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-top: 10px;
}

.ex_modal-count {
  font-size: 12px;
  color: var(--ex-subtle);
}

.ex_modal-thanks {
  font-size: 13px;
  color: var(--ex-ok);
}

.ex_modal-list {
  margin-top: 18px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ex_modal-item {
  margin: 0;
  padding: 10px 12px;
  border-radius: 10px;
  background: #1b1b1b;
  font-size: 14px;
  line-height: 1.45;
  color: #e6e6e6;
  overflow-wrap: anywhere;
}

.ex_modal-empty {
  margin: 0;
  font-size: 14px;
  color: var(--ex-subtle);
}

.ex_link-btn {
  display: block;
  margin: 18px auto 0;
  padding: 0;
  border: 0;
  background: none;
  color: var(--ex-subtle);
  font-size: 12px;
  font-family: inherit;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
}

.ex_link-btn:hover {
  color: var(--ex-error);
}

/* ── Footer / Initiumnet signage ── */
.ex_footer {
  border-top: 1px solid #262626;
  padding: 28px 16px 32px;
  text-align: center;
}

.ex_signage {
  margin: 0;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.ex_signage-by {
  font-size: 11px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--ex-subtle);
}

.ex_signage-name {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.32em;
  color: #ffffff;
}

.ex_copyright {
  margin: 10px 0 0;
  font-size: 12px;
  color: var(--ex-subtle);
}

@media (prefers-reduced-motion: reduce) {
  .ex_page * {
    transition: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Pages/AccountPage/Components/Explore/UAExploreGridLayout.css"],"names":[],"mappings":"AAAA,qEAAqE;AACrE,+FAA+F;;AAE/F;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;;EAEnB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,8EAA8E;EAC9E,mCAAmC;AACrC;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,iCAAiC;EACjC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,oBAAoB;AACtB;;AAEA,6BAA6B,WAAW,gDAAgD,EAAE,EAAE;AAC5F,6BAA6B,WAAW,gDAAgD,EAAE,EAAE;AAC5F,6BAA6B,WAAW,gDAAgD,EAAE,EAAE;AAC5F,6BAA6B,WAAW,gDAAgD,EAAE,EAAE;;AAE5F,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,0BAA0B;EAC1B,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;GAGG;;AAEH;;;GAGG;;AAEH,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;;WAGS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA,4EAA4E;AAC5E;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;;IAEE,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,8BAA8B,EAAE,gCAAgC;EAClE;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF","sourcesContent":["/* Copyright (c) 2025 Initiumnet Technologies. All Rights Reserved. */\n/* Explore Features — dark, equal-height cards: 1 per row on phones, up to 5 on wide screens. */\n\n.ex_page {\n  --ex-bg: #000000;\n  --ex-card: #0e0e0e;\n  --ex-border: #2a2a2a;\n  --ex-text: #ffffff;\n  --ex-muted: #b4b4b4;\n  --ex-subtle: #8c8c8c;\n  --ex-accent: #4da3ff;\n  --ex-ok: #3ddc84;\n  --ex-error: #ff6b6b;\n\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: var(--ex-bg);\n  color: var(--ex-text);\n  font-family: \"Inter\", \"Segoe UI\", system-ui, -apple-system, Roboto, sans-serif;\n  -webkit-font-smoothing: antialiased;\n}\n\n.ex_page *,\n.ex_page *::before,\n.ex_page *::after {\n  box-sizing: border-box;\n}\n\n.ex_main {\n  flex: 1;\n  width: 100%;\n  max-width: 1760px;\n  margin: 0 auto;\n  padding: 24px 16px 32px;\n}\n\n@media (min-width: 640px) {\n  .ex_main {\n    padding: 32px 24px 40px;\n  }\n}\n\n/* ── Header ── */\n.ex_header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.ex_header-left {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  min-width: 0;\n}\n\n.ex_logo {\n  width: 56px;\n  height: 56px;\n  flex-shrink: 0;\n  object-fit: contain;\n  border-radius: 14px;\n}\n\n.ex_header-title {\n  margin: 0;\n  font-size: clamp(22px, 3.2vw, 34px);\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ex_settings-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  height: 42px;\n  padding: 0 16px;\n  border: 1px solid #3a3a3a;\n  border-radius: 10px;\n  background: rgba(36, 36, 45, 0.4);\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.ex_settings-btn:hover {\n  border-color: #6e6e6e;\n}\n\n@media (max-width: 480px) {\n  .ex_settings-label {\n    display: none;\n  }\n  .ex_settings-btn {\n    padding: 0 12px;\n  }\n  .ex_logo {\n    width: 44px;\n    height: 44px;\n  }\n}\n\n/* ── Summary bar ── */\n.ex_summary {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 24px;\n  padding: 14px 18px;\n  border: 1px solid var(--ex-border);\n  border-radius: 12px;\n  background: rgba(36, 36, 45, 0.3);\n  font-size: 14px;\n  color: var(--ex-muted);\n}\n\n.ex_summary-total {\n  font-size: 20px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.ex_summary-total span,\n.ex_price span {\n  margin-left: 2px;\n  font-size: 12px;\n  font-weight: 400;\n  color: var(--ex-subtle);\n}\n\n/* ── Grid: 1 → 2 → 3 → 4 → 5 columns ── */\n.ex_grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 20px;\n  align-items: stretch;\n}\n\n@media (min-width: 600px)  { .ex_grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } }\n@media (min-width: 960px)  { .ex_grid { grid-template-columns: repeat(3, minmax(0, 1fr)); } }\n@media (min-width: 1280px) { .ex_grid { grid-template-columns: repeat(4, minmax(0, 1fr)); } }\n@media (min-width: 1600px) { .ex_grid { grid-template-columns: repeat(5, minmax(0, 1fr)); } }\n\n/* ── Card ── */\n.ex_card {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  height: 100%;\n  overflow: hidden;\n  border: 1px solid var(--ex-border);\n  border-radius: 16px;\n  background: var(--ex-card);\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.ex_card:hover {\n  border-color: #3d3d3d;\n}\n\n/* .ex_card--selected {\n  border-color: rgba(77, 163, 255, 0.55);\n  box-shadow: 0 0 0 1px rgba(77, 163, 255, 0.25);\n} */\n\n/* .ex_card--locked {\n  border-color: rgba(61, 220, 132, 0.5);\n  box-shadow: 0 0 0 1px rgba(61, 220, 132, 0.2);\n} */\n\n/* Video window: always 16:9 */\n.ex_video {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  flex-shrink: 0;\n  overflow: hidden;\n  background: #1a1a1a;\n}\n\n.ex_video img,\n.ex_video iframe {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n  object-fit: cover;\n  display: block;\n}\n\n.ex_video-sample {\n  position: absolute;\n  inset: 0;\n  background:\n    radial-gradient(120% 90% at 20% 0%, rgba(77, 163, 255, 0.35), transparent 60%),\n    radial-gradient(100% 80% at 100% 100%, rgba(160, 107, 255, 0.35), transparent 60%),\n    #141414;\n}\n\n.ex_play {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n}\n\n.ex_play svg path:first-child {\n  transition: fill 0.15s;\n}\n\nbutton.ex_play:hover svg path:first-child,\nbutton.ex_play:focus-visible svg path:first-child {\n  fill: #ff0000;\n}\n\nbutton.ex_play:focus-visible {\n  outline: 3px solid var(--ex-accent);\n  outline-offset: -3px;\n}\n\n.ex_play--soon {\n  cursor: default;\n}\n\n.ex_soon {\n  padding: 3px 10px;\n  border-radius: 999px;\n  background: rgba(0, 0, 0, 0.6);\n  font-size: 11px;\n  color: #e5e5e5;\n}\n\n/* Body: the Add / Remove button always sits at the bottom so rows line up */\n.ex_body {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding: 14px 16px 18px;\n}\n\n.ex_card-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 22px;\n}\n\n.ex_code {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  color: var(--ex-subtle);\n}\n\n.ex_badge {\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: rgba(77, 163, 255, 0.15);\n  color: #9ccbff;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.ex_badge--default {\n  background: rgba(61, 220, 132, 0.15);\n  color: var(--ex-ok);\n}\n\n.ex_name-row {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: 6px;\n}\n\n.ex_name {\n  margin: 0;\n  min-width: 0;\n  font-size: 17px;\n  font-weight: 600;\n  line-height: 1.3;\n}\n\n.ex_price {\n  margin: 0;\n  flex-shrink: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.ex_subtitle {\n  margin: 6px 0 0;\n  font-size: 14px;\n  line-height: 1.45;\n  color: #dcdcdc;\n}\n\n.ex_desc {\n  margin: 6px 0 0;\n  font-size: 13px;\n  line-height: 1.5;\n  color: var(--ex-muted);\n}\n\n.ex_meta {\n  display: flex;\n  gap: 8px;\n  margin: 14px 0 16px;\n}\n\n.ex_meta-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 30px;\n  padding: 0 10px;\n  border: 1px solid #333333;\n  border-radius: 999px;\n  background: transparent;\n  color: var(--ex-muted);\n  font-size: 12px;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.ex_meta-btn:hover {\n  border-color: #6e6e6e;\n  color: #ffffff;\n}\n\n.ex_meta-btn--on {\n  border-color: rgba(77, 163, 255, 0.6);\n  color: var(--ex-accent);\n}\n\n/* ── Buttons ── */\n.ex_btn,\n.ex_included {\n  width: 100%;\n  height: 44px;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 600;\n  font-family: inherit;\n}\n\n.ex_body > .ex_btn,\n.ex_body > .ex_included {\n  margin-top: auto;\n}\n\n.ex_btn {\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\n}\n\n.ex_btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.ex_btn:focus-visible,\n.ex_meta-btn:focus-visible,\n.ex_settings-btn:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(77, 163, 255, 0.45);\n}\n\n.ex_btn--add {\n  border: 1px solid #ffffff;\n  background: #ffffff;\n  color: #000000;\n}\n\n.ex_btn--add:hover:not(:disabled) {\n  background: #e2e2e2;\n}\n\n.ex_btn--remove {\n  border: 1px solid #6e6e6e;\n  background: transparent;\n  color: #ffffff;\n}\n\n.ex_card .ex_btn--remove:hover {\n  border-color: var(--ex-error);\n  color: var(--ex-error);\n}\n\n.ex_btn--small {\n  width: auto;\n  height: 38px;\n  padding: 0 18px;\n  font-size: 14px;\n}\n\n.ex_included {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border: 1px solid rgba(61, 220, 132, 0.5);\n  color: var(--ex-ok);\n}\n\n/* ── Page actions ── */\n.ex_actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 36px;\n}\n\n.ex_actions-right {\n  display: flex;\n  gap: 12px;\n}\n\n.ex_btn--wide {\n  width: auto;\n  min-width: 150px;\n  height: 48px;\n  padding: 0 22px;\n}\n\n.ex_actions > .ex_btn--wide:hover {\n  border-color: #ffffff;\n}\n\n@media (max-width: 599px) {\n  .ex_actions,\n  .ex_actions-right {\n    flex-direction: column;\n    align-items: stretch;\n    width: 100%;\n  }\n  .ex_btn--wide {\n    width: 100%;\n  }\n  .ex_actions-right {\n    flex-direction: column-reverse; /* Save above Cancel on phones */\n  }\n}\n\n.ex_error {\n  margin: 14px 0 0;\n  text-align: right;\n  font-size: 14px;\n  color: var(--ex-error);\n}\n\n/* ── Reviews dialog ── */\n.ex_modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  background: rgba(0, 0, 0, 0.75);\n  backdrop-filter: blur(4px);\n}\n\n.ex_modal {\n  position: relative;\n  width: 100%;\n  max-width: 480px;\n  max-height: calc(100vh - 32px);\n  overflow-y: auto;\n  padding: 28px 24px 22px;\n  border: 1px solid #333333;\n  border-radius: 18px;\n  background: #121212;\n  color: #ffffff;\n}\n\n.ex_modal-close {\n  position: absolute;\n  top: 10px;\n  right: 12px;\n  width: 34px;\n  height: 34px;\n  border: 0;\n  background: transparent;\n  color: var(--ex-muted);\n  font-size: 24px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.ex_modal-title {\n  margin: 0 32px 16px 0;\n  font-size: 19px;\n  font-weight: 600;\n}\n\n.ex_modal-textarea {\n  width: 100%;\n  min-height: 96px;\n  padding: 12px 14px;\n  border: 1px solid #4a4a4a;\n  border-radius: 10px;\n  background: #0a0a0a;\n  color: #ffffff;\n  font-size: 15px;\n  font-family: inherit;\n  resize: vertical;\n}\n\n.ex_modal-textarea:focus {\n  outline: none;\n  border-color: var(--ex-accent);\n  box-shadow: 0 0 0 3px rgba(77, 163, 255, 0.3);\n}\n\n.ex_modal-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  margin-top: 10px;\n}\n\n.ex_modal-count {\n  font-size: 12px;\n  color: var(--ex-subtle);\n}\n\n.ex_modal-thanks {\n  font-size: 13px;\n  color: var(--ex-ok);\n}\n\n.ex_modal-list {\n  margin-top: 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.ex_modal-item {\n  margin: 0;\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: #1b1b1b;\n  font-size: 14px;\n  line-height: 1.45;\n  color: #e6e6e6;\n  overflow-wrap: anywhere;\n}\n\n.ex_modal-empty {\n  margin: 0;\n  font-size: 14px;\n  color: var(--ex-subtle);\n}\n\n.ex_link-btn {\n  display: block;\n  margin: 18px auto 0;\n  padding: 0;\n  border: 0;\n  background: none;\n  color: var(--ex-subtle);\n  font-size: 12px;\n  font-family: inherit;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n  cursor: pointer;\n}\n\n.ex_link-btn:hover {\n  color: var(--ex-error);\n}\n\n/* ── Footer / Initiumnet signage ── */\n.ex_footer {\n  border-top: 1px solid #262626;\n  padding: 28px 16px 32px;\n  text-align: center;\n}\n\n.ex_signage {\n  margin: 0;\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n}\n\n.ex_signage-by {\n  font-size: 11px;\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n  color: var(--ex-subtle);\n}\n\n.ex_signage-name {\n  font-size: 20px;\n  font-weight: 700;\n  letter-spacing: 0.32em;\n  color: #ffffff;\n}\n\n.ex_copyright {\n  margin: 10px 0 0;\n  font-size: 12px;\n  color: var(--ex-subtle);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .ex_page * {\n    transition: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
